var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M17.875 6.874 16.51 8.24l-2.75-2.75 1.366-1.366c.385-.385.88-.568 1.375-.568s.99.183 1.375.568c.76.761.76 1.99 0 2.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "m15.867 8.891-9.909 9.9a1.943 1.943 0 1 1-2.75-2.75l9.91-9.9 2.75 2.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "m9.12 3.208.377-1.274a.355.355 0 0 0-.083-.34.349.349 0 0 0-.348-.091l-1.274.376-1.274-.376a.355.355 0 0 0-.34.082.334.334 0 0 0-.082.34l.367 1.283-.376 1.274c-.037.12 0 .248.082.34.092.091.22.118.34.082l1.283-.367 1.274.376c.037.01.064.018.1.018a.371.371 0 0 0 .248-.1.334.334 0 0 0 .083-.34L9.12 3.208Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "m5.454 8.708.376-1.274a.355.355 0 0 0-.083-.34.334.334 0 0 0-.339-.082l-1.283.367-1.274-.376a.355.355 0 0 0-.34.082.334.334 0 0 0-.082.34l.367 1.283-.376 1.274c-.037.12 0 .248.082.34.092.091.22.119.34.082l1.274-.376 1.274.376a.344.344 0 0 0 .1.009.371.371 0 0 0 .248-.1.334.334 0 0 0 .083-.34l-.367-1.265Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "m19.204 13.291.376-1.274a.355.355 0 0 0-.082-.34.334.334 0 0 0-.34-.082l-1.274.376-1.274-.376a.355.355 0 0 0-.34.083.334.334 0 0 0-.082.339l.376 1.274-.376 1.274c-.036.12 0 .248.083.34.091.091.22.119.339.082l1.274-.376 1.274.376c.028.01.064.01.101.01a.371.371 0 0 0 .248-.102.334.334 0 0 0 .082-.339l-.385-1.265Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.02743 4.02546 -3.03872 -3.0402 18.006 3.922)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-11.36936 11.36143 -8.57647 -8.58246 14.627 7.174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.95618 2.95845 -2.23326 -2.23154 9.19 1.758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.9549 2.9483 -2.2256 -2.23058 5.522 7.257)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(135.077 7.193 9.91) scale(4.1658 3.14465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.500e23fddfa25aa5c8175b8253153cfd.svg";
export { ForwardRef as ReactComponent };